'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, form) {
    window.$.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $(form).prepend('<div class="contact-us-signup-message"></div>');
    }
    $('.contact-us-signup-message').append('<div class="contact-us-signup-alert alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
    }, 3000);
}

module.exports = {
    subscribeContact: function () {
        $('.contact-us-form').on('bouncerFormValid', function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr('action');

            window.$.spinner().start();
            $.ajax({
                url: url,
                type: 'POST',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    displayMessage(data, form);
                    if (data.success) {
                        $('.contact-us-form').trigger('reset');
                    }
                },
                error: function (err) {
                    displayMessage(err, form);
                }
            });
        });
    }
};
